import hljs from 'highlight.js/lib/core';

// Register only languages we need (avoid full highlight.js import)
import javascript from 'highlight.js/lib/languages/javascript';
import json from 'highlight.js/lib/languages/json';
import bash from 'highlight.js/lib/languages/bash';
import xml from 'highlight.js/lib/languages/xml'; // HTML / XML
import css from 'highlight.js/lib/languages/css';

hljs.registerLanguage( 'javascript', javascript );
hljs.registerLanguage( 'js', javascript );
hljs.registerLanguage( 'json', json );
hljs.registerLanguage( 'bash', bash );
hljs.registerLanguage( 'shell', bash );
hljs.registerLanguage( 'xml', xml );
hljs.registerLanguage( 'html', xml );
hljs.registerLanguage( 'css', css );

import 'highlight.js/styles/docco.css';

document.querySelectorAll( '.e-stn--glossary-inner-content pre' ).forEach( ( el ) => {
  hljs.highlightElement( el );
} );
